/**
 * Created by harris on 17-3-5.
 */
import * as Util from 'lib/Util'
import Vue from 'vue'

export const directive =  {
  'text-cut': function (el, binding) {
    let {value, oldValue, arg, modifiers} = binding;
    let content = value,
      oldContent = oldValue;
    arg = parseInt(arg, 10);
    if (typeof value !== 'string' && Number.isNaN(arg)) {
      arg = value.num || 0;
      content = value.content;
      oldContent = oldValue.content;
    }
    if (content !== oldContent) {
      el.innerText = Util.textCut(content, arg, modifiers.dot);
    }
  },
  clamp: {
    inserted (el, binding) {
      let {value, oldValue, arg} = binding;
      let content = value,
        oldContent = oldValue;
      arg = parseInt(arg, 10);
      if (typeof value !== 'string' && Number.isNaN(arg)) {
        arg = value.line || 0;
        content = value.content;
        oldContent = oldValue.content;
      }

      if (content !== oldContent) {
        el.innerText = content;
        require('lib/Clamp')(el, {clamp: arg});
      }
    }
  }
};

Object.keys(directive).forEach(key => Vue.directive(key, directive[key]));



// WEBPACK FOOTER //
// ./src/directive/index.js